﻿const positionDropdown = (container, element, setTop = true) => {
	const dropdownHeight = container.offsetHeight;
	const dropdownWidth = container.offsetWidth;
	const inputBounds = element.getBoundingClientRect();

	var top = window.pageYOffset + inputBounds.top + element.offsetHeight + 2 + 8;
	var left = window.pageXOffset + inputBounds.left;
	var right = window.document.body.offsetWidth - inputBounds.right;
	var rightMost = left + dropdownWidth > window.document.body.offsetWidth;
	var centerMost = right + dropdownWidth > window.document.body.offsetWidth;

	if (setTop) {
		container.style.top = top + "px";
	}

	if (!rightMost) {
		container.style.left = setTop ? left + "px" : 0;
		container.style.right = "auto";
	}
	else if (!centerMost) {
		container.style.left = "auto";
		container.style.right = setTop ? right + "px" : 0;
	} else {
		var bodyWidth = window.document.body.offsetWidth;
		var centerLeft = Math.max(0, bodyWidth / 2 - dropdownWidth / 2);
		if (setTop) {
			container.style.left = centerLeft + "px";
		}
		container.style.right = "auto";
	}
}



export default positionDropdown;